const ROOT_DIR = 'src/pages'

module.exports = {
    home: {
        path: '/',
        component: `${ROOT_DIR}/index.js`
    },

    successStories: {
        path: '/success-stories',
        component: `${ROOT_DIR}/success-stories.js`
    },

    products: {
        path: '/products',
        component: `${ROOT_DIR}/products.js`
    },

    solutions: {
        path: '/solutions',
        component: `${ROOT_DIR}/solutions.js`
    },

    detailedStories: {
        path: '/detailed-stories',
        component: `${ROOT_DIR}/detailed-stories.js`
    },

    privacyPolicy: {
        path: '/privacy-policy',
        component: `${ROOT_DIR}/detailed-stories.js`
    },

    termsAndConditions: {
        path: '/terms-and-conditions',
        component: `${ROOT_DIR}/terms-and-conditions.js`
    },

    advertiserDiscount: {
        path: '/advertiser-discount',
        component: `${ROOT_DIR}/advertiser-discount.js`
    },
    faq: {
        path: '/frequently-asked-questions',
        component: `${ROOT_DIR}/frequently-asked-questions.js`
    },
    success: {
        path: '/success',
        component: `${ROOT_DIR}/success.js`
    },
    success: {
        path: '/event',
        component: `${ROOT_DIR}/event.js`
    },
}